import { useState } from "react";
import { Trash2, Loader2 } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { toast } from "sonner";
import api from "@/lib/api";

export const ConfirmDelete = ({ url, title, description, onDone, label = "", testId, className = "" }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { const { data } = await api.delete(url); toast.success(data.message || "Deleted"); onDone?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Delete failed"); } finally { setBusy(false); }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button type="button" disabled={busy} title="Delete" className={`inline-flex items-center gap-1 p-1.5 rounded text-red-600 hover:bg-red-50 text-xs font-semibold disabled:opacity-50 ${className}`} data-testid={testId}>
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Trash2 className="w-3.5 h-3.5" />}{label}
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent className="bg-white">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description} This can't be undone.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testId}-cancel`}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={go} className="bg-red-600 hover:bg-red-500 text-white" data-testid={`${testId}-confirm`}>Delete for good</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
